import { useDataUser } from "@data/auth";
import { useGroups } from "@data/group";
import { useAuthStore } from "@mod/auth";
import { AnalyticsWrapper } from "@mod/core/config/initialize-analytics";
import { LoadingSpinner } from "@mod/core/ui";
import { useIsMobile } from "@mod/core/utils/use-is-mobile";
import { PostHogProvider } from "posthog-js/react";
import { Navigate, Outlet, useLocation, useNavigation } from "react-router-dom";
import { APP_ROUTES } from "../router";
import { redirectToNewDomain } from "./lib/redirect-to-new-domain";
import { DesktopSidebar } from "./ui/desktop-sidebar";
import { UserHeaderWrapper } from "./ui/user-header-wrapper";

export const {
  ENV_POSTHOG_KEY,
  ENV_POSTHOG_HOST
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
} = dmenv;

export const ProyectedLayout = () => {
  const isAuthenticated = useAuthStore.use.isAuthenticated();
  const { isLoading: isLoadingUser } = useDataUser();
  const { isLoading: isLoadingGroups } = useGroups();
  const navigation = useNavigation();
  const location = useLocation();
  const isMobile = useIsMobile();
  const isNavigating = navigation.state === "loading";

  const isHome = location.pathname === APP_ROUTES.HOME;
  const showSidebar = !isMobile && isHome;

  const isLoading = isLoadingUser || isLoadingGroups || isNavigating;

  redirectToNewDomain();

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.LOGIN} replace />;
  }

  return (
    <PostHogProvider
      apiKey={ENV_POSTHOG_KEY}
      options={{
        api_host: ENV_POSTHOG_HOST
      }}
    >
      <div className="flex flex-row h-svh bg-slate-100 overflow-hidden w-full">
        {!isLoading && showSidebar && <DesktopSidebar />}
        <div className="flex flex-col flex-1 overflow-hidden w-full max-w-full">
          {!isLoading && (
            <>
              <UserHeaderWrapper />
              <AnalyticsWrapper />
              <main className="flex-grow overflow-auto resize-none">
                <Outlet />
              </main>
            </>
          )}
          {isLoading && (
            <div className="flex-1 flex items-center justify-center">
              <LoadingSpinner />
            </div>
          )}
        </div>
      </div>
    </PostHogProvider>
  );
};
